module.exports = __webpack_public_path__ + "img/EXC.7ec3d39b.svg";